module.exports = __webpack_public_path__ + "static/img/bh.ef135f3c.svg";